export const categories = [
  { id: "all", name: "全部" },
  { id: "scene", name: "名场面爆料" },
  { id: "reversal", name: "高能反转" },
  { id: "backstage", name: "幕后花絮" },
  { id: "comment", name: "神评论截图" },
  { id: "funny", name: "沙雕名镜头" },
  { id: "heart", name: "情感大瓜" },
];